'use client';

import { ApolloProvider } from '@apollo/client/react';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, Suspense, useRef } from 'react';
import { ToastContainer } from 'react-toastify';

import App from './App';
import { caloTheme } from './assets/themes/calo';
import { AskToLeave, LeaveGuardContext } from './hooks/useLeaveGuard';
import { GraphQLClient } from './libs/graphQL';
import { queryClient } from './libs/queryClient';
import AuthGate from './views/Authentication';

// The leave guard sits above the ToastContainer, which renders the toasts' links outside App.
const Root = ({ children }: { children: ReactNode }) => {
  const leaveGuard = useRef<AskToLeave | null>(null);

  return (
    <ApolloProvider client={GraphQLClient}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={caloTheme}>
          <LeaveGuardContext.Provider value={leaveGuard}>
            <Suspense fallback={<section />}>
              <ToastContainer limit={3} closeOnClick draggable />
              <AuthGate>
                {({ signOut, user }) => (
                  <App signOut={signOut} user={user}>
                    {children}
                  </App>
                )}
              </AuthGate>
            </Suspense>
          </LeaveGuardContext.Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </ApolloProvider>
  );
};

export default Root;
